import React from 'react';
import { Shield, Eye, Wallet, Zap, MapPin } from 'lucide-react';
import { whyChooseUs } from '../../data/mock';

const benefitIcons = {
  1: Shield,
  2: Eye,
  3: Wallet,
  4: Zap,
  5: MapPin
};

export const WhyChooseUsSection = () => {
  return (
    <section id="mengapa-kami" className="relative bg-[#0a0a0a] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-[7.6923%]">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-[#00FFD1] text-sm font-medium tracking-wider uppercase mb-4">
            Mengapa Memilih Kami
          </span>
          <h2 className="text-white text-3xl md:text-4xl lg:text-5xl font-semibold leading-tight mb-6">
            Kepercayaan Pelanggan adalah{' '}
            <span className="text-[#00FFD1]">Prioritas Kami</span>
          </h2>
          <p className="text-white/60 text-lg max-w-2xl mx-auto">
            Dengan pengalaman bertahun-tahun, kami berkomitmen memberikan 
            layanan terbaik untuk setiap pelanggan.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {whyChooseUs.map((benefit, index) => {
            const Icon = benefitIcons[benefit.id];
            return (
              <div
                key={benefit.id}
                className={`group relative p-8 border border-white/10 bg-black/50 hover:border-[#00FFD1]/30 transition-all duration-400 ${
                  index === 4 ? 'lg:col-span-1 lg:col-start-2' : ''
                }`}
              >
                {/* Number */}
                <span className="absolute top-4 right-4 text-[#00FFD1]/20 text-6xl font-bold">
                  0{benefit.id}
                </span>
                
                {/* Content */}
                <div className="relative z-10">
                  <div className="w-12 h-12 bg-[#00FFD1] flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-400">
                    <Icon className="w-6 h-6 text-black" />
                  </div>
                  <h3 className="text-white text-xl font-semibold mb-3">
                    {benefit.title}
                  </h3>
                  <p className="text-white/60 text-base leading-relaxed">
                    {benefit.description}
                  </p>
                </div>

                {/* Hover Effect Line */}
                <div className="absolute bottom-0 left-0 w-0 h-1 bg-[#00FFD1] group-hover:w-full transition-all duration-400" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
